import api from "../../api";

class CupSales {
  index() {
    return api.get('venda/copos');
   }
  store(data) {
    return api.post('venda/copos', data);
  }
  searchPlaceCupSales(description) {
    return api.get(`search/venda/copos/${description}`);
  }
}

export default new CupSales();
